var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AlertTriangle = function AlertTriangle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M13 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V9ZM13 15a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0V15Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.99 1.968a3 3 0 0 0-2.62 1.538L2.275 15.75a.996.996 0 0 0-.062.125 3 3 0 0 0 2.625 4.125c.037.002.072.002.107 0L5 20h14.007a3 3 0 0 0 2.76-4.125.999.999 0 0 0-.062-.126L14.61 3.506a3 3 0 0 0-2.62-1.538ZM5 18c-.019 0-.037 0-.055.002H4.94a1 1 0 0 1-.895-1.321l7.06-12.18.009-.017a1 1 0 0 1 1.75 0l.01.017 7.058 12.179a1 1 0 0 1-.937 1.32H5Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default AlertTriangle;